'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./PlaylistHomeButton.scss');

var PlaylistHomeButton = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(PlaylistHomeButton, _PureComponent);

  function PlaylistHomeButton() {
    (0, _classCallCheck3.default)(this, PlaylistHomeButton);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistHomeButton.__proto__ || (0, _getPrototypeOf2.default)(PlaylistHomeButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistHomeButton, [{
    key: 'onClick',
    value: function onClick() {
      var push = this.context.push;

      push('/');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hidden = _props.hidden;
      var t = this.context.t;


      if (hidden) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.homeBtn, className) },
        _react2.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-stroke', onClick: this.onClick },
          _react2.default.createElement('i', { className: 'icon-home' }),
          _react2.default.createElement(
            'span',
            { className: 'margin-left-10' },
            t('Home')
          )
        )
      );
    }
  }]);
  return PlaylistHomeButton;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  hidden: _propTypes2.default.bool
}, _class2.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  onClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = PlaylistHomeButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlist/components/PlaylistHomeButton/PlaylistHomeButton.js
// module id = 2179
// module chunks = 1